import Layout from '@/layout'

const SystemMonitorRouter = {
  path: '/SystemMonitor',
  component: Layout,
  redirect: 'noredirect',
  name: 'SystemMonitor',
  meta: {
    title: '系统监控',
    icon: 'daohang-ziliaoguanli'
    // roles: ['subsystem']
  },
  children: [
    {
      path: 'SopEmailRecord',
      component: () => import('@/views/cargo/v0/SystemMonitor/sopEmailRecord'),
      name: 'SopEmailRecord',
      meta: { title: '消息推送日志' },
      roles: ['module_fmSopEmailLogModule']
    },
    {
      path: 'SearchLog',
      component: () => import('@/views/cargo/v0/SystemMonitor/SearchLog'),
      name: 'SearchLog',
      meta: { title: '查询方案日志' },
      roles: []
    },
    {
      path: 'SharedChargeRecord',
      component: () => import('@/views/cargo/v0/SystemMonitor/sharedChargeRecord'),
      name: 'SharedChargeRecord',
      meta: { title: '费用分摊记录' },
      roles: ['module_SharedChargeRecord']
    },
    {
      path: 'DataUpdateLog',
      component: () => import('@/views/cargo/v0/SystemMonitor/dataUpdateLog'),
      name: 'DataUpdateLog',
      meta: { title: '数据更新日志' },
      roles: ['module_DataUpdateLog']
    },
    {
      path: 'CheckRuleResults',
      component: () => import('@/views/cargo/v0/SystemMonitor/checkRuleResults'),
      name: 'CheckRuleResults',
      meta: { title: '验证结果日志' },
      roles: ['module_CheckRuleResults']
    }
  ]
}

export default SystemMonitorRouter
